import _defineProperty from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/regenerator";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isLocalChain } from '../helpers';
import { useEthers } from '../hooks';
import { useBlockNumber } from './blockNumber';
import { useConfig, useUpdateConfig } from './config';
import multicallABI from '../constants/abi/MultiCall.json';
import { deployContract } from '../helpers/contract';
var LocalMulticallState;

(function (LocalMulticallState) {
  LocalMulticallState[LocalMulticallState["Unknown"] = 0] = "Unknown";
  LocalMulticallState[LocalMulticallState["NonLocal"] = 1] = "NonLocal";
  LocalMulticallState[LocalMulticallState["Deploying"] = 2] = "Deploying";
  LocalMulticallState[LocalMulticallState["Deployed"] = 3] = "Deployed";
  LocalMulticallState[LocalMulticallState["Error"] = 4] = "Error";
})(LocalMulticallState || (LocalMulticallState = {}));

export function LocalMulticallProvider(_ref) {
  var children = _ref.children;
  var updateConfig = useUpdateConfig();

  var _useConfig = useConfig(),
      multicallAddresses = _useConfig.multicallAddresses;

  var _useEthers = useEthers(),
      library = _useEthers.library,
      chainId = _useEthers.chainId;

  var _useState = useState(LocalMulticallState.Unknown),
      _useState2 = _slicedToArray(_useState, 2),
      localMulticallState = _useState2[0],
      setLocalMulticallState = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      multicallBlockNumber = _useState4[0],
      setMulticallBlockNumber = _useState4[1];

  var blockNumber = useBlockNumber();
  useEffect(function () {
    if (!library || !chainId) {
      setLocalMulticallState(LocalMulticallState.Unknown);
    } else if (!isLocalChain(chainId)) {
      setLocalMulticallState(LocalMulticallState.NonLocal);
    } else if (multicallAddresses && multicallAddresses[chainId]) {
      setLocalMulticallState(LocalMulticallState.Deployed);
    } else if (localMulticallState !== LocalMulticallState.Deploying) {
      var signer = library.getSigner();

      if (!signer) {
        setLocalMulticallState(LocalMulticallState.Error);
        return;
      }

      setLocalMulticallState(LocalMulticallState.Deploying);

      var deployMulticall = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _yield$deployContract, contractAddress, _blockNumber;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return deployContract(multicallABI, signer);

                case 3:
                  _yield$deployContract = _context.sent;
                  contractAddress = _yield$deployContract.contractAddress;
                  _blockNumber = _yield$deployContract.blockNumber;
                  updateConfig({
                    multicallAddresses: _defineProperty({}, chainId, contractAddress)
                  });
                  setMulticallBlockNumber(_blockNumber);
                  setLocalMulticallState(LocalMulticallState.Deployed);
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  setLocalMulticallState(LocalMulticallState.Error);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        }));

        return function deployMulticall() {
          return _ref2.apply(this, arguments);
        };
      }();

      deployMulticall();
    }
  }, [library, chainId]);
  var awaitingMulticallBlock = multicallBlockNumber && blockNumber && blockNumber < multicallBlockNumber;

  if (localMulticallState === LocalMulticallState.Deploying || localMulticallState === LocalMulticallState.Deployed && awaitingMulticallBlock) {
    return _jsx("div", {
      children: "Deploying multicall..."
    }, void 0);
  } else if (localMulticallState === LocalMulticallState.Error) {
    return _jsx("div", {
      children: "Error deploying multicall contract"
    }, void 0);
  } else {
    return _jsx(_Fragment, {
      children: children
    }, void 0);
  }
}